import { Field } from 'components/Wizards/Field/Field'
import { RepresentationAge } from './RepresentationAge'
import { RepresentationGender } from './RepresentationGender'
import { RepresentationCulture } from './RepresentationCulture'
import { RepresentationDetails } from './RepresentationDetails'
import cx from 'classnames'
import Styles from './RepresentationPreferences.module.scss'

type Props = {
  ageRange?: string
  gender?: string
  culture?: string
  details?: string
  onAgeRangeUpdate: (ageRange: string) => void
  onGenderUpdate: (gender: string) => void
  onCultureUpdate: (culture: string) => void
  onDetailsUpdate: (details: string) => void
  hideDetails?: boolean
}

const RepresentationPreferences = ({
  ageRange,
  gender,
  culture,
  details,
  onAgeRangeUpdate,
  onGenderUpdate,
  onCultureUpdate,
  onDetailsUpdate,
  hideDetails = false,
}: Props) => {
  return (
    <Field label="Who Appears in Content" headingLevel={3} data-testid="representation-preferences">
      <div className={Styles.fieldGroup}>
        <div className={Styles.fields}>
          <div className={Styles.field}>
            <RepresentationAge ageRange={ageRange} onUpdate={onAgeRangeUpdate} />
          </div>
          <div className={Styles.field}>
            <RepresentationGender gender={gender} onUpdate={onGenderUpdate} />
          </div>
          <div className={Styles.field}>
            <RepresentationCulture culture={culture} onUpdate={onCultureUpdate} />
          </div>
        </div>
        {!hideDetails && (
          <div className={cx(Styles.fields, Styles.detailsField)}>
            <RepresentationDetails details={details} onUpdate={onDetailsUpdate} />
          </div>
        )}
      </div>
    </Field>
  )
}

export { RepresentationPreferences }
